import SwaggerParser from 'swagger-parser'
import { APIDisplayOverrides } from '../../constants/CustomSettings'

export function swagger2Loader (config, { onLoadProgress, onNewAPI, onNewOperation, onNewDefinition, onLoadCompleted, onLoadError }) {
  const url = config.url.getUrl()
  onLoadProgress(`Loading API Spec from ${url}`)

  return SwaggerParser.validate(url)
    .then(function (api) {
      let newApi = api
      let defaultHost = `${window.location.origin}/${config.basePath}`

      newApi = config.interceptor({ friendlyName: config.friendlyName, url: config.url }, api)
      swagger2SpecLoader(newApi, config.friendlyName, config.slug, defaultHost, { onLoadProgress, onNewAPI, onNewOperation, onLoadCompleted, onLoadError }, config.debugMode)
    })
    .catch(function (err) {
      onLoadError(err)
    })
}

export function swagger2SpecLoader (apiSpec, friendlyName, slug, defaultHost, { onLoadProgress, onNewAPI, onNewOperation, onLoadCompleted, onLoadError }, debugMode = false) {
  onLoadProgress(`API Spec received with success`)
  onLoadProgress(`Starting API parsing`)

  // defaults
  apiSpec = Object.assign({
    definitions: [],
    basePath: '/'
  }, apiSpec)
  apiSpec.host = `${apiSpec.schemes[0]}://${apiSpec.host}` || defaultHost

  if (!debugMode)
  {
    // override any default display settings, for example, hide certain API's or hide certain parameters of certain API's
    setupCustomDisplay(apiSpec.paths);
  }

  onNewAPI(apiSpec)

  Object.keys(apiSpec.paths)
    .forEach(url => {
      Object.keys(apiSpec.paths[url])
        .filter(key => key !== 'parameters')
        .forEach(httpMethod => {
          const operation = apiSpec.paths[url][httpMethod]
          const urlClean = url
            .replace(/^\//g, '')
            .replace(/\//g, '-')
            .replace(/\{|\}/g, '_')

          const id = `${slug}-${httpMethod}-${urlClean}`
          if (!operation.tags || operation.tags.length === 0) {
            operation.tags = ['']
          }
          const operationSpec = { id, url, httpMethod, ...operation }
          onLoadProgress(`Processing operation ${id}`)
          onNewOperation(operationSpec)
        })
    })
  onLoadProgress(`Loading completed`)
  onLoadCompleted(apiSpec)
}

function setupCustomDisplay(apiSpecPaths)
{
  // have specified API's to hide?
  if(APIDisplayOverrides.hideApi.length > 0)
  {
    // hide any specified API's
    Object.keys(apiSpecPaths).filter(key => APIDisplayOverrides.hideApi.indexOf(key) > -1).forEach(deleteItem => delete apiSpecPaths[deleteItem]);
  }

  // have specified parameters of specified API's to hide?
  if(APIDisplayOverrides.hideApiParameter.length <= 0)
  {
    // no
    return;
  }

  // hide any specified parameters of API's
  Object.keys(apiSpecPaths).forEach(function(url) {
    // url is the API name, like "/GetCatalog"
    Object.keys(apiSpecPaths[url]).filter(key => key !== 'parameters').forEach(function(httpMethod) {
      // httpMethod is the request type key (like 'get') that contains the request 'parameters' array
      for(let i = 0; i < APIDisplayOverrides.hideApiParameter.length; ++i)
      {
        // is this an API which has parameters requested to be hidden?
        if(APIDisplayOverrides.hideApiParameter[i].apiName === url && apiSpecPaths[url][httpMethod].parameters)
        {
          // this API does have requested hidden parameters, determine which ones?
          for(let j = apiSpecPaths[url][httpMethod].parameters.length - 1; j >= 0; --j)
          {
            for(let k = 0; k < APIDisplayOverrides.hideApiParameter[i].parameterNamesToHide.length; ++k)
            {
              // is this a parameter for this API that needs to be hidden?
              if(APIDisplayOverrides.hideApiParameter[i].parameterNamesToHide[k] === apiSpecPaths[url][httpMethod].parameters[j].name)
              {
                // yes, delete the entry from the parameters array
                apiSpecPaths[url][httpMethod].parameters.splice(j,1);
                break;
              }
            }
          }
        }
      }
    })
  });
}



// WEBPACK FOOTER //
// ./src/infrastructure/loaders/swagger2Loader.js